import styled from 'styled-components';
import { CommonDiv } from 'styles/common';
import CloseIcon from 'assets/images/close-24.svg';

const ModalCloseIcon = styled.img.attrs({
  src: CloseIcon
})`
  float: right;
  &:hover {
    cursor: pointer;
  }
`;

const ModalTitle = styled(CommonDiv)`
  clear: both;
  text-align: left;
  font-size: 24px;
  margin-bottom: 20px;
`;

const ModalText = styled(CommonDiv)`
  text-align: left;
  font-size: 18px;
  margin-bottom: 30px;
`;

const ModalCancel = styled.a`
  cursor: pointer;
  font-family: 'HelveticaNeue', 'Helvetica Neue';
  font-size: 1em;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(p) => p.theme.color.error};
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  left: 0;
`;

const ModalButtonConfirm = styled.button`
  cursor: pointer;
  border: 0;
  padding: 0.72em 0;
  font-family: ${props => props.theme.fontFamily};
  font-size: 1em;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  background-color: ${props =>
    props.disabled ? props.theme.color.label : props.theme.color.primary};
  margin-right: 0.938em;
  width: 100%;
  max-width: 140px;
`;

const ModalLine = styled.div`
  margin-top: 20px;
  height: 1px;
  background-color: ${props => props.theme.color.border};
  margin: 0px -15px 15px -30px;
`;

const BlockPatientButton = styled(CommonDiv.withComponent('button'))`
  background: #fff;
  border-radius: 4px;
  font-weight: 500;
  color: ${props => props.theme.color.error};
  border: solid 2px ${props => props.theme.color.error};
  padding: 10px 0px;
  width: 140px;
  margin-right: 30px;
`;

const Form = styled.div`
  margin-right: 15px;
`;

export {
  ModalCloseIcon,
  ModalTitle,
  ModalText,
  ModalCancel,
  ModalButtonConfirm,
  ModalLine,
  BlockPatientButton,
  Form
};
